if (!customElements.get("qeydo-care")) {
  customElements.define(
    "qeydo-care",
    class QeydoCare extends HTMLElement {
      connectedCallback() {
        this.checkbox = this.querySelector("[data-qeydo-care-checkbox]");
        this.total = this.querySelector("[data-qeydo-care-total]");
        this.totalValue = this.querySelector("[data-qeydo-care-total-value]");
        this.productPrice = Number(this.dataset.productPrice || 0);

        const priceElement = document.getElementById(`price-${this.dataset.sectionId}`);
        this.productPrice = Number(priceElement?.dataset?.productPrice || this.productPrice);
        if (!this.productPrice) {
          const variantInput = document.querySelector(`#product-form-${this.dataset.sectionId} [name="id"]`);
          this.productPrice = Number(variantInput?.dataset?.price || 0);
        }

        this.checkbox?.addEventListener("change", () => this.render());
        this.querySelector(".qeydo-care__terms")?.addEventListener("click", (event) => event.stopPropagation());
        document.addEventListener("variant:change", (event) => {
          if (event.detail?.sectionId !== this.dataset.sectionId) return;
          this.productPrice = Number(event.detail.variant?.price || 0);
          this.render();
        });
        this.render();
      }

      formatMoney(cents) {
        if (typeof window.formatMoney === "function") {
          return window.formatMoney(cents);
        }
        return `${new Intl.NumberFormat("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(cents / 100)} dh`;
      }

      render() {
        const checked = Boolean(this.checkbox?.checked);
        if (this.total) this.total.hidden = !checked;
        const dynamicCheckout = this.closest(".product__buy-buttons")?.querySelector(".product-form__checkout");
        if (dynamicCheckout) dynamicCheckout.hidden = checked;
        if (checked && this.totalValue && this.productPrice) {
          this.totalValue.textContent = this.formatMoney(this.productPrice + Number(this.dataset.carePrice || 0));
        }
      }
    }
  );
}
